import { MimeType } from "@/types";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// get ext from url
export const getExtensionFromUrl = (url: string) => {
  const path = url.split("?")[0] || "";
  const ext = path.split(".")?.pop()?.toLowerCase();
  return ext || "";
};

// get mimeType from url
export const getMimeTypeFromUrl = (url: string): MimeType | string => {
  const ext = getExtensionFromUrl(url);
  switch (ext) {
    case "jpg":
      return MimeType.JPG;
    case "jpeg":
      return MimeType.JPEG;
    case "png":
      return MimeType.PNG;
    case "gif":
      return MimeType.GIF;
    case "webp":
      return MimeType.WEBP;
    case "mp4":
      return MimeType.MP4;
    case "mp3":
      return MimeType.MP3;
    case "pdf":
      return MimeType.PDF;
    case "doc":
      return MimeType.DOC;
    case "docx":
      return MimeType.DOCX;
    case "xls":
      return MimeType.XLS;
    case "xlsx":
      return MimeType.XLSX;
    case "csv":
      return MimeType.CSV;
    case "txt":
      return MimeType.TXT;
    case "mov":
      return MimeType.MOV;
    case "mkv":
      return MimeType.MKV;
    case "wav":
      return MimeType.WAV;
    case "flac":
      return MimeType.FLAC;
    case "ppt":
    case "pptx":
      return MimeType.PPTX;
    case "svg":
      return MimeType.SVG;
    default:
      return "";
  }
};

// check image from mimeType
export const checkImageFromMimeType = (mimeType?: string) => {
  return (
    mimeType === MimeType.JPEG ||
    mimeType === MimeType.PNG ||
    mimeType === MimeType.GIF ||
    mimeType === MimeType.WEBP ||
    mimeType === MimeType.SVG ||
    mimeType === MimeType.JPG
  );
};

// check video from mimeType
export const checkVideoFromMimeType = (mimeType?: string) => {
  return (
    mimeType === MimeType.MP4
    // mimeType === MimeType.MOV ||
    // mimeType === MimeType.MKV
  );
};

export { cn };
